module.exports = [{
      plugin: require('C:/Users/Adrian Beria/Desktop/Programacion/PROYECTOS/gatsby-portfolio/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/Adrian Beria/Desktop/Programacion/PROYECTOS/gatsby-portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
